import { NgModule } from "@angular/core";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatRadioModule } from "@angular/material/radio";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs"
import { MatMenuModule } from "@angular/material/menu"
import { MatExpansionModule} from "@angular/material/expansion"
import { MatProgressBarModule } from "@angular/material/progress-bar";

const MATERIAL = [
    MatAutocompleteModule,
    MatIconModule,
    MatPaginatorModule,
    MatTableModule,
    MatFormFieldModule,
    MatSortModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,

    MatCheckboxModule,
    MatChipsModule,
    MatRadioModule,
    MatDividerModule,
    MatButtonToggleModule,
    MatTabsModule,
    MatMenuModule,
    MatExpansionModule,
    MatProgressBarModule
]

@NgModule({
    imports: MATERIAL,
    exports: MATERIAL
})
export class MaterialModule{}